import classNames from "classnames";
import {memo, useMemo} from "react";
import {CONSTANTS} from "../../../../constants/constants";
import s from "./SelectBtn.module.css";

const {START, END} = CONSTANTS.VALUE.POSITION_ICON_BTN;

export const SelectBtn = memo(({
  name,
  callback,
  isDisabled,
  iconConfig = {},
  isActive = false,
  width = 'max-content',
}) => {

  const colorContent = isActive ? 'var(--color-main)' :  'var(--paragraph-color)';

  const {
    enabled = false,
    position = "END",
    icon = null,
  } = iconConfig;

  const Icon = useMemo(
    () => enabled ? <span className={s.icon}>{icon?.(colorContent)}</span> : null,
    [enabled, icon, colorContent]
  );

  return (
    <button
      className={classNames(s.wrapper, {[s.active]: isActive})}
      type={'button'}
      onClick={callback}
      disabled={isDisabled}
      style={{width}}
    >
      <div className={s.content}>
        {position === START && Icon}
        {name && <p className={s.name}>{name}</p>}
        {position === END && Icon}
      </div>
    </button>
  )
});